// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"137":"53a1fe5b","171":"3c3a987a"}[chunkId] + ".chunk.css";
};